<template>
  <div>
    <h4 class="title has-text-centered is-4">{{ story ? 'Story Details' : 'New Story' }}</h4>

    <div class="columns">
      <div class="column is-6">
        <form @submit="handleSubmit">
          <b-field label="ID" custom-class="is-small">
            <b-input v-model="formData.id" size="is-small"></b-input>
          </b-field>

          <b-field label="Title" custom-class="is-small">
            <b-input v-model="formData.title" size="is-small"></b-input>
          </b-field>

          <b-field label="Description" custom-class="is-small">
            <b-input v-model="formData.description" type="textarea" size="is-small"></b-input>
          </b-field>

          <b-button type="is-success" native-type="submit">{{ story ? 'Update' : 'Create' }}</b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Quest } from '@/services/api';

export default {
  name: 'story-form',
  props: {
    story: Object,
  },
  watch: {
    story: {
      immediate: true,
      handler(val) {
        if (val) {
          this.formData = {
            ...val,
          };
        }
      },
    },
  },
  data() {
    return {
      errors: [],
      formData: {
        id: null,
        title: null,
        description: null,
      },
      loadingForm: false,
      sent: false,
    };
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();

      this.errors = [];
      this.loadingForm = true;

      const action = this.story ? Quest.updateStory(this.story.id, this.formData) : Quest.createStory(this.formData);

      action
        .then(() => {
          this.sent = true;
          if (this.story) {
            this.refreshStory();
          } else {
            this.refreshStories();
          }
        })
        .catch((error) => {
          const responseError = error.response.data;

          // Validation errors
          if (responseError.errors) {
            Object.keys(responseError.errors).forEach((key) => {
              this.errors.push(responseError.errors[key][0]);
            });

            // General error
          } else {
            this.errors.push('Sorry :( Something went wrong... please try again later');
          }
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    refreshStory() {
      this.$store.dispatch('quest/loadStoryDetails', this.story.id);
    },
    refreshStories() {
      this.$store.dispatch('quest/loadStories');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
